class AuthService {
    constructor() {
        this.token = this.getTokenFromStorage();
    }

    // Obtener el token desde localStorage (user_data)
    getTokenFromStorage() {
        const userDataStr = localStorage.getItem('user_data');
        if (userDataStr) {
            try {
                const userData = JSON.parse(userDataStr);
                return userData.token;
            } catch (error) {
            }
        }
        return null;
    }

    // Obtener el token actual
    getToken() {
        return this.token;
    }

    // Establecer el token
    setToken(token) {
        this.token = token;
        const userDataStr = localStorage.getItem('user_data');
        if (userDataStr) {
            try {
                const userData = JSON.parse(userDataStr);
                userData.token = token;
                localStorage.setItem('user_data', JSON.stringify(userData));
            } catch (error) {
            }
        }
    }

    // Verificar si hay un token válido
    isAuthenticated() {
        // Siempre verificar el localStorage para evitar desincronizaciones
        const token = this.getTokenFromStorage();
        this.token = token; // Sincronizar el token en memoria
        return !!token;
    }

    // Hacer logout
    logout() {
        this.token = null;
        localStorage.removeItem('user_data');
    }

    // Obtener headers con autorización
    getAuthHeaders() {
        const headers = {
            'Content-Type': 'application/json',
        };

        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        return headers;
    }

    // Hacer request autenticado
    async authenticatedRequest(url, options = {}) {
        const headers = {
            ...this.getAuthHeaders(),
            ...options.headers,
        };

        const response = await fetch(url, {
            ...options,
            headers,
        });

        // Si el token expiró, limpiar el token y redirigir al login
        if (response.status === 401) {
            this.logout();
            // Redirigir al login
            window.location.href = '/login';
            throw new Error('Token expirado');
        }

        return response;
    }
}

// Crear instancia singleton
const authService = new AuthService();

export default authService;
